/** @format */
import React from "react";

import Text from "../Text";

export default (props) => {
  return <Text {...props}>Loading...</Text>;
};
